<template>
  <div>
    <div class="grid gap-x-8 sm:grid-cols-1 md:grid-cols-1">
      <div class="panel">
        <div class="panel-body">
          <harvest-weekly :data="harvests_weekly" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <ok-discard-weekly :data="totals_weekly" />
        </div>
      </div>
      <div class="panel" v-if="false">
        <div class="panel-body">
          <crop-sizes :data="crop_sizes" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <crop-size-packages-by-weeks :data="crop_size_packages_by_weeks" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OkDiscardWeekly from "@/components/views/agro_exporter/production/query_by_provider/charts/OkDiscardWeekly.vue";
import CropSizes from "@/components/views/producer/reporting/process/charts/CropSizes.vue";
import HarvestWeekly from "@/components/views/agro_exporter/production/query_by_provider/charts/HarvestWeekly.vue";
import CropSizePackagesByWeeks from "@/components/views/agro_exporter/production/query_by_provider/charts/CropSizePackagesByWeeks.vue";
export default {
  name: "AEProductionQueryByProviderShowProviderWeekly",
  components: {
    OkDiscardWeekly,
    CropSizes,
    HarvestWeekly,
    CropSizePackagesByWeeks
  },
  props: {
    provider_id: { required: true },
    provider_type: { required: true },
    agro_exporter_process_id: { required: true },
    harvests_weekly: { required: true },
    totals_weekly: { required: true },
    crop_sizes: { required: true },
    crop_size_packages_by_weeks: { required: true }
  },
  data() {
    return {};
  }
};
</script>
